"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OnClickOutside_1 = require("./OnClickOutside");
exports.default = OnClickOutside_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/behaviors/OnClickOutside/index.js
// module id = 1835
// module chunks = 8